import { CardItem, type DCFTableCopy, LoadingSkeleton, PageGridContainer, PageGridItem, TableDCF, tokens } from 'ComponentLibrary'
import { useValuationDCFPage } from './ValuationDCFPage.data'
import { Headline } from 'ComponentLibrary/src/piazza/text/Headline/Headline'
import { Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'

export default function ValuationDCFPage() {
    const { t: tCommon } = useTranslation('terminology', { keyPrefix: 'common' })
    const { t: tValuationDCFPage } = useTranslation('pages', { keyPrefix: 'assets.assetDetails.valuation.valuationDCFPage' })
    const dcfTableCopy: DCFTableCopy = {
        columnLabels: {
            period: (period) => tValuationDCFPage('table.columnLabels.period', { period }),
            exit: tValuationDCFPage('table.columnLabels.exit'),
        },
        sections: {
            marketRent: tValuationDCFPage('table.sections.marketRent'),
            revenue: tValuationDCFPage('table.sections.revenue'),
            costs: tValuationDCFPage('table.sections.costs'),
            presentValueCalculation: tValuationDCFPage('table.sections.presentValueCalculation'),
        },
        rows: {
            grossRevenue: tValuationDCFPage('table.rows.grossRevenue'),
            totalCosts: tValuationDCFPage('table.rows.totalCosts'),
            discountFactor: tValuationDCFPage('table.rows.discountFactor'),
            totalNetRevenue: tValuationDCFPage('table.rows.totalNetRevenue'),
            presentValue: tValuationDCFPage('table.rows.presentValue'),
            terminalValue: tValuationDCFPage('table.rows.terminalValue'),
            presentValueTotal: tValuationDCFPage('table.rows.presentValueTotal'),
            presentValueAfterTransactionCosts: tValuationDCFPage('table.rows.presentValueAfterTransactionCosts'),
            rounded: tValuationDCFPage('table.rows.rounded'),
        },
    }
    const { dcfData, isDcfPending } = useValuationDCFPage(dcfTableCopy)

    return (
        <PageGridContainer>
            <PageGridItem columnSpan={6} columnSpanXs={4}>
                <CardItem>
                    <Headline variant="headline3" title={tCommon('prices')} />
                    {isDcfPending && (
                        <Stack direction="column" gap={tokens.SizingSpacing200} paddingTop={tokens.SizingSpacing150}>
                            <LoadingSkeleton count={5} variant="rounded" height="100px" />
                        </Stack>
                    )}
                    {dcfData && <TableDCF {...dcfData} />}
                </CardItem>
            </PageGridItem>
        </PageGridContainer>
    )
}
